/** Browser recovery data only. Authentication and grading data never enter here. */
const databaseName = "sat-practice-recovery-v1";
function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(databaseName, 1);
    request.onupgradeneeded = () => request.result.createObjectStore("records");
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    request.onblocked = () => reject(new Error("Local recovery storage is blocked by another tab"));
  });
}
export async function readDraft<T>(key: string): Promise<T | undefined> {
  const db = await open();
  try { return await new Promise((resolve, reject) => { const request = db.transaction("records").objectStore("records").get(key); request.onsuccess = () => resolve(request.result as T | undefined); request.onerror = () => reject(request.error); }); }
  finally { db.close(); }
}
export async function writeDraft(key: string, value: unknown): Promise<void> {
  const db = await open();
  try { await new Promise<void>((resolve, reject) => { const transaction = db.transaction("records", "readwrite"); transaction.objectStore("records").put(value, key); transaction.oncomplete = () => resolve(); transaction.onerror = () => reject(transaction.error); transaction.onabort = () => reject(transaction.error); }); }
  finally { db.close(); }
}
export async function clearAccountDrafts(userId: string): Promise<void> {
  const db = await open();
  try { await new Promise<void>((resolve, reject) => {
    const transaction = db.transaction("records", "readwrite");
    const store = transaction.objectStore("records");
    const cursor = store.openCursor();
    cursor.onsuccess = () => { const entry = cursor.result; if (!entry) return; if (String(entry.key).startsWith(`${userId}:`)) entry.delete(); entry.continue(); };
    transaction.oncomplete = () => resolve(); transaction.onerror = () => reject(transaction.error);
  }); } finally { db.close(); }
}
export async function listDrafts<T>(prefix: string): Promise<Array<{ key: string; value: T }>> {
  const db = await open();
  try { return await new Promise((resolve, reject) => {
    const entries: Array<{ key: string; value: T }> = [];
    const request = db.transaction("records").objectStore("records").openCursor();
    request.onsuccess = () => { const cursor = request.result; if (!cursor) { resolve(entries); return; } if (String(cursor.key).startsWith(prefix)) entries.push({ key: String(cursor.key), value: cursor.value as T }); cursor.continue(); };
    request.onerror = () => reject(request.error);
  }); } finally { db.close(); }
}

/** Prune only immutable question caches; never evict pending response drafts. */
export async function pruneQuestionCaches(userId: string, currentKey: string) {
  const db = await open();
  try { await new Promise<void>((resolve, reject) => {
    const transaction = db.transaction("records", "readwrite");
    const store = transaction.objectStore("records");
    const request = store.openKeyCursor();
    let retained = 0;
    request.onsuccess = () => {
      const cursor = request.result;
      if (!cursor) return;
      const key = String(cursor.key);
      if (key.startsWith(`${userId}:questions:`) && key !== currentKey && ++retained > 2) store.delete(cursor.key);
      cursor.continue();
    };
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
    transaction.onabort = () => reject(transaction.error);
  }); } finally { db.close(); }
}
